// extracted by mini-css-extract-plugin
module.exports = {"link":"_-_-pharmacy-src-answer-answerInformation-answerFeedback__link--1OQwe","text":"_-_-pharmacy-src-answer-answerInformation-answerFeedback__text--3mdKb"};